import React, { FC } from 'react';

type IProps = {
    hasError: boolean | undefined;
    errorText: string;
    id: string;
};

const InputError: FC<IProps> = ({ hasError, errorText, id }) => {
    return hasError ? (
        <div id={id} className="mt-1 text-sm text-red-500">
            {errorText}
        </div>
    ) : null;
};

export default InputError;
